import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Tooltip from "module-common/Tooltip";
import Icon from "module-common/Icon";
import TreePicker from "module-common/TreePicker";
import Label from "./Label";
import AddButton from "./AddButton";

export default class LabelList extends Component {
  static propTypes = {
    labels: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        color: PropTypes.any
      })
    ),
    tree: PropTypes.array,
    editable: PropTypes.bool,
    onAdd: PropTypes.func,
    onRemove: PropTypes.func,
    onChange: PropTypes.func,
    position: PropTypes.string
  };
  static defaultProps = {
    labels: [],
    tree: [],
    editable: false
  };

  render() {
    return (
      <Wrapper {...this.props}>
        {this.props.editable ? this.renderEditable() : this.renderViewable()}
      </Wrapper>
    );
  }

  renderEditable = () => {
    let renders = [];
    const { labels, tree, onRemove, onChange, position, maxMenuScroll } = this.props;
    let counter = 0;
    for (const label of labels) {
      renders.push(
        <Label
          key={label.label + counter}
          name={label.label}
          color={label.color}
          onRemove={() => {
            if (onRemove) onRemove(label);
          }}
          removable
        />
      );
      counter++;
    }

    //add pickers
    if (tree.length > 0) {
      renders.push(
        <TreePicker
          key="add"
          tree={tree}
          onSelected={this.onAdd}
          onChange={onChange}
          position={position}
          maxMenuScroll={maxMenuScroll}
        >
          <AddButton />
        </TreePicker>
      );
    }

    return renders;
  };

  onAdd = option => {
    const onAdd = this.props.onAdd;
    if (onAdd) onAdd(option);
  };

  renderViewable = () => {
    const propsLabels = this.props.labels;
    const length = propsLabels.length;
    let counter = 0;
    let tooltip = [];
    let labels = [];

    for (const label of propsLabels) {
      if (counter < 3 || (counter === 3 && counter === length - 1)) {
        labels.push(
          <Label
            key={label.label + counter}
            name={label.label}
            color={label.color}
          />
        );
      } else {
        tooltip.push(label.label);
      }
      counter++;
    }

    if (tooltip.length > 0) {
      labels.push(
        <Tooltip key="more" position="bottom" text={tooltip.join("\n")}>
          <Icon name="more-label" height={11} />
        </Tooltip>
      );
    }

    return labels;
  };
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;



// WEBPACK FOOTER //
// ./src/module-common/label-list/TreeLabelList.js